module.exports = {
  "zones": {
    "Asia/Kathmandu": ["z", {
      "wallclock": 504921600000,
      "format": "+0545",
      "abbrev": "+0545",
      "offset": 20700000,
      "posix": 504901800000,
      "save": 0
    }, {
      "wallclock": -1577923200000,
      "format": "+0530",
      "abbrev": "+0530",
      "offset": 19800000,
      "posix": -1577943676000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 20476000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};